import { useEffect, useRef, useState } from "react";
import { Box, Chip, Tooltip } from "@mui/material";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../../../../shell/store/types";
import { searchItems } from "../../../../../../../shell/store/content";
import { createSelector } from "reselect";
const getNumOfItemsToRender = (parentWidth: number, children: HTMLCollection) => {
  if (!children) return;
  let validIndex = 0;
  let calculatedWidth = 32; //Padding

  [...children]?.forEach((chip, index) => {
    calculatedWidth = calculatedWidth + chip?.clientWidth + 4;
    if (calculatedWidth <= parentWidth) {
      validIndex = index;
    }
  });
  return validIndex;
};
const selectContent = (state: AppState) => state.content;
const selectContentCount = createSelector([selectContent], content => Object.keys(content).length);
type OneToManyCellProps = {
  items: any[];
};
export const OneToManyCell = ({
  items
}: OneToManyCellProps) => {
  const contentCount = useSelector(selectContentCount, shallowEqual);
  const chipContainerRef = useRef<HTMLDivElement>();
  const [lastValidIndex, setLastValidIndex] = useState(contentCount - 1);
  const parentWidth = chipContainerRef.current?.parentElement?.clientWidth;
  const hiddenItems = items?.length - lastValidIndex - 1;
  const dispatch = useDispatch();
  useEffect(() => {
    setLastValidIndex(getNumOfItemsToRender(parentWidth, chipContainerRef.current?.children));
  }, [parentWidth]);
  useEffect(() => {
    items?.forEach((id: string) => {
      if (id?.startsWith("7-")) {
        dispatch(searchItems(id));
      }
    });
  }, [dispatch]);
  return <>
      <Box display="flex" gap={0.5} alignItems="center" height="100%" data-sentry-element="Box" data-sentry-source-file="OneToManyCell.tsx">
        {items?.slice(0, lastValidIndex + 1)?.map((id: string, index: number) => {
        return <Chip key={index} label={id} size="small" />;
      })}
        {!!hiddenItems && <Tooltip title={`${items?.slice(lastValidIndex + 1)?.join(", ")}`} placement="top-start">
            <Chip label={`+${hiddenItems}`} size="small" />
          </Tooltip>}
      </Box>
      {/** Element below is only needed to calculate the actual chip widths */}
      <Box visibility="hidden" display="flex" gap={0.5} ref={chipContainerRef} data-sentry-element="Box" data-sentry-source-file="OneToManyCell.tsx">
        {items?.map((id: string, index: number) => {
        return <Chip key={index} label={id} size="small" />;
      })}
      </Box>
    </>;
};